import { shape, string, func } from 'prop-types';

export default shape({
  label: string.isRequired,
  Content: func.isRequired
});
